import { render, staticRenderFns } from "./ProcessDialog.vue?vue&type=template&id=4f7cbc90&scoped=true"
import script from "./ProcessDialog.vue?vue&type=script&lang=js"
export * from "./ProcessDialog.vue?vue&type=script&lang=js"
import style0 from "./ProcessDialog.vue?vue&type=style&index=0&id=4f7cbc90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7cbc90",
  null
  
)

export default component.exports